<template>
  <div class="about">
    <p>Сайт о мероприятиях, которые делают жизнь лучше</p>
  </div>
</template>
